import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';
import { NewButton as Button } from 'components/Button';
import { ToggleableContext } from 'utilsTS/hooks';
import styles from './Dropdown.module.scss';

const DropdownActionButton = ({ closeOnClick, onClick, className, children, ...rest }) => {
    const { close } = useContext(ToggleableContext);

    const handleClick = (event) => {
        if (closeOnClick) close();
        onClick(event);
    };

    const classNames = cx(styles.button, className);

    return (
        <Button {...rest} className={classNames} onClick={handleClick}>
            {children}
        </Button>
    );
};

DropdownActionButton.displayName = 'DropdownActionButton';

DropdownActionButton.propTypes = {
    closeOnClick: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
};

DropdownActionButton.defaultProps = {
    closeOnClick: true,
    onClick: noop,
    className: null,
    children: null,
};

export default DropdownActionButton;
